import { useCallback } from "react";
import axios, { BASE_URL } from "app/api/axios";
import useAuth from "./useAuth";

const ACCESS_TOKEN_TTL = 15 * 60 * 1000; // 15 min

// Shared promise to deduplicate concurrent refresh calls
let refreshPromise = null;

const useRefreshToken = () => {
  const { setAuth, logout } = useAuth();

  const refresh = useCallback(async () => {
    if (refreshPromise) {
      return refreshPromise;
    }

    refreshPromise = (async () => {
      try {
        const response = await axios.post(
          BASE_URL + "/Refresh.php",
          {},
          {
            withCredentials: true, // ✅ required for HttpOnly cookie
          }
        );

        const result = response.data;

        if ((response.status === 200 || response.status === 201) && result.status === 1) {
          const newAccessToken = result.accessToken || result.Data?.SessionID;
          const user = result.user || result.Data;
          const permissions =
            result.permissions ||
            result.Permissions ||
            result.Data?.Permissions ||
            [];

          // ✅ store only access token (short-lived)
          localStorage.setItem("accessToken", newAccessToken);
          localStorage.setItem(
            "tokenExpiry",
            Date.now() + ACCESS_TOKEN_TTL
          );

          // ✅ update context
          setAuth({
            user,
            permissions,
            accessToken: newAccessToken,
          });

          return newAccessToken;
        }
        // invalid refresh
        logout();
        throw new Error("Refresh failed");
      } catch (err) {
        logout();
        throw err;
      } finally {
        refreshPromise = null;
      }
    })();

    return refreshPromise;
  }, [setAuth, logout]);

  return refresh;
};

export default useRefreshToken;